import { createTheme, createVariant, globalTheme } from '@cld/component-theme';

export const dropdownMenuTheme = createTheme({
  byMinWidth: {
    sm: { minWidth: '100px' },
    md: { minWidth: '200px' },
    lg: { minWidth: '300px' },
    xl: { minWidth: '500px' },
    none: { minWidth: 'none' },
  },
  menu: {
    padding: {
      vertical: globalTheme.spacing.xs,
    },
  },
});

export interface ThemeProps {
  minWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'none';
}

export const minWidthVariant = createVariant((props: ThemeProps) => dropdownMenuTheme.byMinWidth[props.minWidth || 'md']);
